import { BrowserModule } from '@angular/platform-browser';
import { PlatformModule } from '@angular/cdk/platform';
import { HttpClientModule, HttpClient} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { OrderTypeComponent } from './components/order-type/order-type.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './material';
import { StoreHomeComponent } from './components/store-home/store-home.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { ComboComponent } from './components/combo/combo.component';
import { TableOrderComponent } from './components/table-order/table-order.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertDialogComponent } from './components/dialogs/alert-dialog/alert-dialog.component';
import { CurrentOrderComponent } from './components/current-order/current-order.component';
import { ItemAddedComponent } from './components/item-added/item-added.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { InputDialogComponent } from './components/dialogs/input-dialog/input-dialog.component';
import { OrderResumeComponent } from './components/order-resume/order-resume.component';
import { OrderSentComponent } from './components/order-sent/order-sent.component';
import { StepperDialogComponent } from './components/dialogs/stepper-dialog/stepper-dialog.component';
import { ComboItemComponent } from './components/combo-item/combo-item.component';
import { PickComboItemComponent } from './components/pick-combo-item/pick-combo-item.component';
import { ActionDialogComponent } from './components/dialogs/action-dialog/action-dialog.component';
import { AdressPickerComponent } from './components/adress-picker/adress-picker.component';
import { OrderBaseDataComponent } from './components/order-base-data/order-base-data.component';
import { CarDescriptionComponent } from './components/car-description/car-description.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { PaycardComponent } from './components/paycard/paycard.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule  } from '@angular/fire/storage';
import { environment } from 'src/environments/environment';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { AddressSearchComponent } from './components/address-search/address-search.component';
import { ConfirmAddressComponent } from './components/confirm-address/confirm-address.component';
import { SummaryDialogComponent } from './components/dialogs/summary-dialog/summary-dialog.component';
import { AddCardComponent } from './components/add-card/add-card.component';
import { LocationPickerComponent } from './components/location-picker/location-picker.component';
import { ConfirmAddressDialogComponent } from './components/dialogs/confirm-address-dialog/confirm-address-dialog.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { OrderTypePickerDialogComponent } from './components/dialogs/order-type-picker-dialog/order-type-picker-dialog.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { RedirectComponent } from './components/redirect/redirect.component';
import { AddressNumberErrorDialogComponent } from './components/dialogs/address-number-error-dialog/address-number-error-dialog.component';
import { MenuItensComponent } from './components/menu-itens/menu-itens.component';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { ContactusComponent } from './components/contactus/contactus.component';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { PickCouponDialogComponent } from './components/dialogs/pick-coupon-dialog/pick-coupon-dialog.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    OrderTypeComponent,
    StoreHomeComponent,
    MenuItemComponent,
    ComboComponent,
    AlertDialogComponent,
    CurrentOrderComponent,
    ItemAddedComponent,
    EditProfileComponent,
    MyProfileComponent,
    InputDialogComponent,
    OrderResumeComponent,
    OrderSentComponent,
    StepperDialogComponent,
    ComboItemComponent,
    PickComboItemComponent,
    ActionDialogComponent,
    AdressPickerComponent,
    OrderBaseDataComponent,
    CarDescriptionComponent,
    TableOrderComponent,
    PaycardComponent,
    AddressSearchComponent,
    ConfirmAddressComponent,
    SummaryDialogComponent,
    AddCardComponent,
    LocationPickerComponent,
    ConfirmAddressDialogComponent,
    OrderTypePickerDialogComponent,
    RedirectComponent,
    AddressNumberErrorDialogComponent,
    MenuItensComponent,
    ContactusComponent,
    NotfoundComponent,
    PickCouponDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MaterialModule,
    RouterModule,
    FormsModule,
    GooglePlaceModule,
    PlatformModule,
    ReactiveFormsModule ,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireAnalyticsModule,
    AngularFireStorageModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    ClipboardModule
  ],
  entryComponents: [AlertDialogComponent, ActionDialogComponent, SummaryDialogComponent, InputDialogComponent, StepperDialogComponent, ConfirmAddressDialogComponent, OrderTypePickerDialogComponent, AddressNumberErrorDialogComponent, PickCouponDialogComponent],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }